import React, { Component } from 'react';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import { monthsObj } from '../../../../constants';
import { getLocalStorageInfo } from '../../../../utils'
require('highcharts/modules/exporting')(Highcharts);

export default class UtilsGraph extends Component{
  constructor(props){
    super(props);
  }
  
  render(){
    var colors = [ '#3c7ac2', '#84b2e8', '#ee7c26','#E6B333', '#d7d7d7', '#999966']
    const { hour_plots, cycle_plots, ctrShortInfo, avgData, assetLabel } = this.props;
    let categories = [], hours = [], cycles = [], avgHours = [], avgCycles = [];
    Object.keys(hour_plots).map((year,index) => {
      categories.push(monthsObj[year.slice(4,6)] + ' ' + year.slice(0,4));
      hours.push(hour_plots[year]);
      cycles.push(cycle_plots[year]);
      if(avgData){
        avgHours.push(parseFloat(avgData.hours))
        avgCycles.push(parseFloat(avgData.cycles))
      }
    });
    const options = {
      chart: {
        type: 'line',
        marginTop: 60,
        events: {
          load: function() {
            if(assetLabel){
              if(ctrShortInfo && ctrShortInfo.lessor_name && ctrShortInfo.lessor_name.name){
                var label = this.renderer.label((ctrShortInfo.msn ? "MSN: " + ctrShortInfo.msn +" | " + assetLabel : ctrShortInfo.esn ? "ESN: " + ctrShortInfo.esn : '') + "<br/>Lessor: " +  ctrShortInfo.lessor_name.name )
              }else{
                var label = this.renderer.label((ctrShortInfo.msn ? "MSN: " + ctrShortInfo.msn +" | " + assetLabel : ctrShortInfo.esn ? "ESN: " + ctrShortInfo.esn : '') + "<br/>Lessor: " + getLocalStorageInfo().defaultLessor.name)
              }
            }
            else if(ctrShortInfo && ctrShortInfo.lessor_name && ctrShortInfo.lessor_name.name){
              var label = this.renderer.label((ctrShortInfo.msn ? "MSN: " + ctrShortInfo.msn +" | " + ctrShortInfo.aircraft_type.name : ctrShortInfo.esn ? "ESN: " + ctrShortInfo.esn : '') + "<br/>Lessor: " +  ctrShortInfo.lessor_name.name )
            }else{
              var label = this.renderer.label((ctrShortInfo.msn ? "MSN: " + ctrShortInfo.msn +" | " + ctrShortInfo.aircraft_type.name : ctrShortInfo.esn ? "ESN: " + ctrShortInfo.esn : '') + "<br/>Lessor: " + getLocalStorageInfo().defaultLessor.name)
            }
              label.css({
                width: '400px',
                fontSize: '9px'
              })
              .attr({
                'stroke': 'silver',
                'stroke-width': 1,
                'r': 2,
                'padding': 5
              })
              .add();

            label.align(Highcharts.extend(label.getBBox(), {
              align: 'left',
              x: 0, // offset
              verticalAlign: 'bottom',
              y: -350 // offset
            }), null, 'spacingBox');

          }
        }
      },
      colors:colors,
      credits: {
        enabled: false,
        text: ctrShortInfo.msn ? "MSN: " + ctrShortInfo.msn +" | " + ctrShortInfo.aircraft_type.name : ctrShortInfo.esn ? "ESN: " + ctrShortInfo.esn : '',
        style:{
          fontSize: 12
        },
        position: {
          align: 'left',
          x:20,
          y:-380
        }
      },
      title: {
        text: ' '
      },
      xAxis: {
        categories: categories
      },
      yAxis: {
        title: {
            text: ''
        },
        labels: {
          formatter: function () {
            return this.value;
          }
        }
      },
      series:[
        {
          name: 'Hours',
          data: hours
        },
        {
          name: 'Avg. Hours',
          data: avgHours
        },
        {
          name: 'Cycles',
          data: cycles
        },
        {
          name: 'Avg. Cycles',
          data: avgCycles
        },
      ],
      exporting: {
        buttons: {
          contextButton: {
            text: 'Export',
            menuItems: [
              {
                text: 'Export as PNG',
                onclick: function () {
                  this.exportChart();
                }
              },
              {
                text: 'Export as SVG',
                onclick: function () {
                  this.exportChart({ type: 'image/svg+xml' });
                }
              },
              {
                text: 'Export as PDF',
                onclick: function () {
                  this.exportChart({ type: 'application/pdf' });
                }
              }
            ]
          }
        }
      }
    }
    return(
      <div>
        <HighchartsReact
          highcharts={Highcharts}
          options={options}
        />
      </div>
    )
  }
}
